import { render, staticRenderFns } from "./SetClassroom.vue?vue&type=template&id=63e11cce&scoped=true"
import script from "./SetClassroom.vue?vue&type=script&lang=js"
export * from "./SetClassroom.vue?vue&type=script&lang=js"
import style0 from "./SetClassroom.vue?vue&type=style&index=0&id=63e11cce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e11cce",
  null
  
)

export default component.exports